module.exports = __webpack_public_path__ + "static/media/Img_3.af053df2.JPG";